import React, { ErrorInfo } from "react";

export interface ErrorBoundaryHandleArguments {
  error: Error;
  errorInfo: ErrorInfo;
}
export type ErrorBoundaryHandleError = (
  args: ErrorBoundaryHandleArguments,
) => void;
export interface ErrorBoundaryProps {
  children?: React.ReactNode;
  onError?: ErrorBoundaryHandleError;
  fallback?:
    | React.ReactNode
    | ((props: ErrorBoundaryHandleArguments) => React.JSX.Element);
}
export type ErrorBoundaryState =
  | {
      hasError: true;
      error: Error;
      errorInfo: ErrorInfo;
    }
  | {
      hasError?: false;
      error?: undefined;
      errorInfo?: undefined;
    };
export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { onError } = this.props;
    if (onError) {
      onError({ error, errorInfo });
    }
    this.setState({
      error,
      errorInfo,
    });
  }
  render() {
    const { fallback: Fallback } = this.props;
    if (this.state.hasError) {
      return typeof Fallback === "function" ? (
        <Fallback error={this.state.error} errorInfo={this.state.errorInfo} />
      ) : (
        (Fallback ?? null)
      );
    }
    return this.props.children;
  }
}
